import "./UserConfirmation.scss"
import React from "react"
import Icon from "./Icon"
import Button from "./Button"

const UserConfirmation = ({ message, loading, onCancel, onConfirm }) => {
  return (
    <div className="UserConfirmation_wrapper">
      <div className="UserConfirmation">
        <p>{message}</p>
        <div className="UserConfirmation_actions">
          <Button onClick={onCancel} disabled={loading} styleType="text">
            Cancel
          </Button>
          {loading ? (
            <Icon name="refresh" spin />
          ) : (
            <Button onClick={onConfirm} disabled={loading} styleType="primary">
              Yes
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

UserConfirmation.displayName = "UserConfirmation"

export default UserConfirmation



// WEBPACK FOOTER //
// ./src/lib/UserConfirmation.js